import {
  type ModalProps,
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Modal as MuiModal,
} from '@mui/material'
import { type DataTestIdAttribute, type HTMLAttributesWithoutStyling } from '../../types'

export type ModalBaseProps = Pick<
  ModalProps,
  | 'children'
  | 'open'
  | 'onClose'
  | 'disablePortal'

  /**
   * When turned on it means you are now responsible for ensuring focus management for accessibility
   */
  | 'disableAutoFocus'
  | 'disableRestoreFocus'
  | 'keepMounted'
> & {
  isFullscreen?: boolean
} & HTMLAttributesWithoutStyling<HTMLDivElement> &
  DataTestIdAttribute

/**
 * Modal
 *
 * Demos:
 * - [Modal](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/constructs-modal--docs)
 *
 */
export const Modal = ({ children, isFullscreen, ...props }: ModalBaseProps) => (
  <MuiModal {...props} className={`${isFullscreen ? 'DhlModal-fullscreen' : ''} DhlModal-container`}>
    {children}
  </MuiModal>
)
